import React from "react";
import { useTranslation } from "react-i18next";
import { useBillingStore } from "../../../stores/billingStore";
import { Button } from "../UIElements/Button";
import { Icon } from "../UIElements/Icon";

/**
 * Full-page upgrade prompt shown when a subscription feature is not available.
 * CTA opens the existing PlanUpgradeModal via billingStore.
 */
const SubscriptionUpgradePage = ({
  featureName,
  title,
  description,
  icon = "Lock",
}) => {
  const { t } = useTranslation("billing");
  const setShowUpgradeModal = useBillingStore(
    (state) => state.setShowUpgradeModal,
  );

  const displayTitle =
    title || t("featureGate.title", { feature: featureName });
  const displayDescription =
    description || t("featureGate.description", { feature: featureName });

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="w-full max-w-lg text-center">
        {/* Icon */}
        <div className="border-border bg-muted mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-lg border">
          <Icon name={icon} className="text-muted-foreground h-10 w-10" />
        </div>

        {/* Title */}
        <h2 className="text-foreground mb-3 text-2xl font-bold">
          {displayTitle}
        </h2>

        {/* Description */}
        <p className="text-muted-foreground mx-auto mb-8 max-w-md text-sm">
          {displayDescription}
        </p>

        {/* CTA */}
        <Button
          type="button"
          onClick={() => setShowUpgradeModal(true)}
          size="touch"
          className="max-w-full whitespace-normal"
        >
          <Icon name="Zap" className="h-4 w-4" />
          {t("featureGate.upgradeButton")}
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionUpgradePage;
